import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { supabase, isSupabaseConfigured } from '../supabaseClient';

function OptOut() {
	const [phone, setPhone] = useState('');
	const [status, setStatus] = useState(null);
	const [submitting, setSubmitting] = useState(false);

	const submit = async (e) => {
		e.preventDefault();
		setSubmitting(true);
		setStatus(null);
		try {
			if (!isSupabaseConfigured) {
				setStatus({ ok: false, msg: 'Opt-out storage is not configured yet. Please reply STOP to any message to opt out.' });
				return;
			}
			await supabase.from('sms_unsubscribes').insert([{
				phone,
				referral_url: window.location.href,
				user_agent: navigator.userAgent,
				website: 'appexconnecthub.com'
			}]);
			setStatus({ ok: true, msg: 'Your number has been added to our opt-out list.' });
			setPhone('');
		} catch (err) {
			console.error(err);
			setStatus({ ok: false, msg: 'Something went wrong. Please try again.' });
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<>
			<Helmet>
				<title>SMS Opt-Out | Apex Specialty Contracting LLC</title>
				<meta name="description" content="Opt out of SMS messages from Apex Specialty Contracting LLC. Enter your mobile number or reply STOP to any message." />
			</Helmet>
			<section className="section">
				<div className="container" style={{ maxWidth: 620 }}>
					<h2 style={{ margin: '0 0 8px' }}>Opt Out of SMS Messages</h2>
					<p className="helper">
						The easiest way to stop receiving text messages from us is to reply <strong>STOP</strong> to
						any message we send. Your number is removed immediately.
					</p>
					<p className="helper">
						You can also submit your mobile number below to add it to our internal opt-out list.
						Opt-outs are honored within 24 hours.
					</p>
					<p className="helper">
						Need help? Call <a href="tel:+19163160696">(916) 316-0696</a> or email{' '}
						<a href="mailto:support@appexconnecthub.com">support@appexconnecthub.com</a>.
					</p>
					<form className="form form-grid" style={{ marginTop: 20, maxWidth: 520 }} onSubmit={submit}>
						<div className="field">
							<label htmlFor="phone">Mobile Phone Number</label>
							<input
								id="phone"
								type="tel"
								placeholder="(555) 000-0000"
								value={phone}
								onChange={(e) => setPhone(e.target.value)}
								required
							/>
						</div>
						<div style={{ gridColumn: '1 / -1', display: 'flex', justifyContent: 'flex-start' }}>
							<button className="btn" type="submit" disabled={submitting}>
								{submitting ? 'Submitting…' : 'Remove My Number'}
							</button>
						</div>
					</form>
					{status && (
						<p className="helper" style={{ color: status.ok ? '#0f6a50' : 'crimson', marginTop: 12, fontWeight: 600 }}>
							{status.msg}
						</p>
					)}
					<p className="helper" style={{ marginTop: 20, fontSize: 12, color: '#888' }}>
						Opting out removes you from marketing messages only. You will still receive transactional messages
						directly related to an active roofing project unless you request otherwise.
					</p>
				</div>
			</section>
		</>
	);
}

export default OptOut;


